export const getNotes = (state) => state.notes?.notes;
